import React from "react";
import jsonp from "@alife/common-jsonp";
import "./index.scss";
export default function CompanyInfo(props) {
  var eurl = props.eurl,
    company = props.company,
    fromShili = props.fromShili,
    isSuperFactory = props.isSuperFactory,
    tpYear = props.tpYear,
    wangpuUrl = props.wangpuUrl,
    loginid = props.loginid,
    docType = props.docType,
    ad_signs_exp = props.ad_signs_exp,
    isPcSem = props.isPcSem;
  var alitalkidUTF8 = encodeURIComponent(loginid + "" || "");
  var hasTpYear = tpYear && tpYear !== "0";
  var getIconUrl = function getIconUrl() {
    if (isSuperFactory) {
      return "https://img.alicdn.com/imgextra/i1/O1CN01jiKOiA1bYVspVHnru_!!6000000003477-2-tps-64-64.png";
    } else if (fromShili && fromShili !== "0") {
      return "https://img.alicdn.com/imgextra/i2/O1CN015dF0Vf1HBnvnirDNf_!!6000000000720-2-tps-64-64.png";
    } else {
      return "https://img.alicdn.com/imgextra/i4/O1CN01dfUfmV204cQbesAjW_!!6000000006796-2-tps-56-56.png";
    }
  };
  var dj = function dj() {
    jsonp({
      callbackParamName: "callback",
      url: eurl
    })["catch"]();
  };
  var renderWangWang = function renderWangWang() {
    if (docType === 'rightbidking' && ad_signs_exp) {
      return /*#__PURE__*/React.createElement("div", {
        className: "bidking"
      }, /*#__PURE__*/React.createElement("img", {
        className: "king-tag",
        src: "https://img.alicdn.com/imgextra/i1/O1CN01Y7AXlU1lmO6Triwk9_!!6000000004861-2-tps-47-43.png"
      }));
    }
    if (docType === 'bidking' && ad_signs_exp) {
      return /*#__PURE__*/React.createElement("div", {
        className: "bidking"
      }, /*#__PURE__*/React.createElement("img", {
        className: "king-tag",
        style: {
          width: '14px'
        },
        src: "https://gw.alicdn.com/imgextra/i3/O1CN01b3iXFY23oMu5MFSGo_!!6000000007302-2-tps-100-88.png"
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "common-wangwang-tag"
    }, /*#__PURE__*/React.createElement("span", {
      className: "J_WangWang",
      "data-nick": alitalkidUTF8,
      "data-encode": "true",
      "data-icon": "static",
      "data-from": "cnalichn",
      "data-display": "inline"
    }));
  };
  if (isPcSem) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "zr-company-info",
    onClick: dj
  }, /*#__PURE__*/React.createElement("a", {
    href: wangpuUrl,
    target: "_blank",
    title: company
  }, /*#__PURE__*/React.createElement("span", {
    className: "company-shili"
  }, /*#__PURE__*/React.createElement("img", {
    src: getIconUrl()
  }), hasTpYear && /*#__PURE__*/React.createElement("span", {
    className: "company-year"
  }, tpYear, "\u5E74")), /*#__PURE__*/React.createElement("span", {
    className: "line"
  }), /*#__PURE__*/React.createElement("span", {
    className: "company-name"
  }, company)), /*#__PURE__*/React.createElement("span", {
    className: "wangwang"
  }, renderWangWang()));
}